'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  PENDING: null,
  APPROVED: null,
  INVALID: null
});